export default __webpack_public_path__ + "static/media/nifty-orbit.e01bf363.svg";